import { Grid } from "@mui/material";
import MainDialogComponent from "@/Layouts/components/Dialogs/MainDialog";
import ImageCropperComponent from "./ImageCropperComponent";
import { TPropsProfilePictureDialogProps } from "../../types/UserProfile";

export default function ProfilePictureDialogComponent(props: Readonly<TPropsProfilePictureDialogProps>) {
	return (
		<Grid>
			<MainDialogComponent
				headerStyle={{ height: "50px" }}
				openDialog={props.open || false}
				onClose={props.onCloseDialog}
				width={750}
			>
				<ImageCropperComponent
					onClose={props.onCloseDialog}
					srcImage={props.imageSrc}
					setUpdatingCallBack={props.setUpdatingCallBack}
					onCloseCallBack={props.onCloseCallBack}
					cacheIndex={"imageProfileDataConversion"}
				/>
			</MainDialogComponent>
		</Grid>
	);
}
